import { useImmerAtom } from 'jotai-immer';
import {
    defaultsTableViewAtom,
    defaultsTableFiltersAtom,
    defaultsTableStatsAtom,
    defaultsDataAtom,
} from './monitordefaults_atoms';
import { MonitorDefaultItem } from '../../data/datamonitorRepo';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useMonitorDefaultsData = (): { items: MonitorDefaultItem[] } => {
    const [view] = useImmerAtom(defaultsTableViewAtom);
    const [filters] = useImmerAtom(defaultsTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(defaultsTableStatsAtom);
    const [data] = useImmerAtom(defaultsDataAtom);

    const { items } = useTableData<MonitorDefaultItem>({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items };
};
